// Import Core
import React, { useEffect } from 'react'
// Import Components
import MapMultipleLocations from './MapMultipleLocations';
import CardListSimple from './CardListSimple';
import FloatingButton from '../ui/buttons/FloatingButton';
// Import Utils
import useMap from '../../utils/useMap';

const MapSlideIn = ({ className, mapSelection, allLocations, tagline }) => {
	const { isMapOpen, toggleMap } = useMap();
	useEffect(() => {
		// Set Map to be open on load
		toggleMap()
	}, [])
  return (
    <div className={className}>
      <h3 className="section-title">Explore The Local Area</h3>
      {(mapSelection && mapSelection.length > 0) && (
        <FloatingButton
          className="slide-in-map-btn"
          value="Open Map"
          clickHandler={toggleMap}
        />
      )}

      <div id="map-wrapper" className={isMapOpen ? 'slide' : ''}>
        {(mapSelection && mapSelection.length > 0) && (
          <MapMultipleLocations
            locations={mapSelection}
            mapItems={mapSelection}
            filterLocation={null}
            isActiveMenuItem={null} />
        )}

        <div className="results-container">
          <CardListSimple
            cardList={allLocations}
            tagline={tagline}
            addLinks={true}
          />
        </div>
      </div>
    </div>
  )
}

export default MapSlideIn